export default {
    UNKNOWN: 0,
    DASH: 1,
    HLS: 2,
    HDS: 3,
    FLASHLS: 4,
    IMMERSIVE_HLS_STEREO_TB: 5,
    IMMERSIVE_DASH_STEREO_TB: 6,
    IMMERSIVE_HLS_STEREO_LR: 7,
    IMMERSIVE_DASH_STEREO_LR: 8,
    IMMERSIVE_HLS_MONO: 9,
    IMMERSIVE_DASH_MONO: 10
};



// WEBPACK FOOTER //
// ./src/js/constants/video-type.js